// extracted by mini-css-extract-plugin
export default {"bg_custom":"client_profile_bg_custom__-4spO","line":"client_profile_line__hw68O","dashboard":"client_profile_dashboard__4PcDi","profiledata":"client_profile_profiledata__ZxnRZ"};